<template>
  <div>
      <default-header></default-header>
  </div>
</template>

<script>
import DefaultHeader from '../components/Headers/DefaultHeader.vue';
export default {
components:{
DefaultHeader
}
}
</script>

<style>

</style>